import { Form, Formik, FormikProps } from 'formik';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import authApis from '../../../APIs/auth';
import logo from '../../../assets/icons/logo.svg';
import { AuthType, useRoot } from '../../../context/RootProvider';
import {
  Alert,
  Button,
  CodeInput,
  Typography,
} from '../../../designComponents';
import { LOGIN_ROUTE } from '../../../routes/routePaths';
import theme from '../../../theme';
import { requestAPI } from '../../../utils';
import {
  ButtonContainer,
  ContentContainer,
  Heading,
  Label,
  LoginContainer,
  Logo,
} from './style';

const VerificationCode = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const formikRef = useRef<FormikProps<{ codeInput: string }>>(null);

  const { auth, updateAuth } = useRoot();
  console.log(auth?.emailAddress);
  const handleVerificationCode = async (values: { codeInput: string }) => {
    try {
      setErrorMessage('');
      setLoading(true);
      const verifyOTP = await requestAPI(
        authApis.verifyOTP({
          emailAddress: auth?.emailAddress ?? '',
          otp: parseInt(values.codeInput, 10),
          otpType: 'REGISTRATION_OTP',
        })
      );
      setLoading(false);

      if (verifyOTP) {
        const updatedData = { ...auth } as AuthType;
        if (updatedData) {
          updatedData.hasEmailVerified = true;
        }
        updateAuth(updatedData);
        toast(verifyOTP.message);
        navigate(LOGIN_ROUTE);
      }
    } catch (error: any) {
      setLoading(false);
      if (typeof error === 'string') {
        setErrorMessage(error);
      }
      if (error.error && typeof error.error === 'string') {
        setErrorMessage(error.error);
      }
      console.error('OTP Verification failed:', error);
    }
  };

  const handleResendCode = async () => {
    try {
      setIsResendDisabled(true);
      await requestAPI(authApis.resendOTP({ otpType: 'REGISTRATION_OTP' }));
      toast('Code sent to your email.');
      formikRef?.current?.resetForm();
      setTimeout(() => {
        setIsResendDisabled(false);
      }, 30000);
    } catch (error) {
      console.error('Failed to resend code:', error);
    }
  };

  return (
    <LoginContainer>
      <ContentContainer>
        <Heading>
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
          >
            <Typography variant="heading" strong>
              Evacuation Plans
            </Typography>
            <Typography style={{ marginLeft: '45px', color: '#3D3D3D' }}>
              SaaS Application
            </Typography>
          </div>
          <div>
            <Logo src={logo} alt="logo" />
          </div>
        </Heading>

        <Label>
          <Typography size={16} color={theme.colors.normalText}>
            Verification Code
          </Typography>
        </Label>

        <Typography style={{ marginBottom: '15px', textAlign: 'center' }}>
          Verify your email address. We have sent you a verification code to
          your email address provided during registration.
        </Typography>
        <Typography
          strong
          style={{ textAlign: 'center', marginBottom: '20px' }}
        >
          {auth?.emailAddress}
        </Typography>
        <Formik
          initialValues={{
            codeInput: '',
          }}
          onSubmit={handleVerificationCode}
          enableReinitialize
          innerRef={formikRef}
        >
          {({ values, setFieldValue, handleSubmit }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <CodeInput
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '40px',
                  }}
                  name="codeInput"
                  value={values.codeInput}
                  onChange={(newValue) => setFieldValue('codeInput', newValue)}
                  numberOfField={6}
                />
                {errorMessage && (
                  <Alert
                    type="error"
                    text={errorMessage}
                    style={{ marginBottom: '20px' }}
                  />
                )}
                <ButtonContainer>
                  <Button
                    onClick={handleResendCode}
                    variant="gray"
                    size="md"
                    isLoading={loading}
                    disabled={isResendDisabled}
                  >
                    Resend Code
                  </Button>
                  <Button
                    htmlType="submit"
                    variant="secondary"
                    size="md"
                    isLoading={loading}
                  >
                    Verify
                  </Button>
                </ButtonContainer>
              </Form>
            );
          }}
        </Formik>
      </ContentContainer>
    </LoginContainer>
  );
};

export default VerificationCode;
